var mod = angular.module('avalanche.config',[]);

mod.constant('avalancheConfig', {  

    //backendAddress: "http://192.168.2.114:8080/paeweb-backend/home",
    //backendAddress: "http://192.168.1.109:8080/paeweb-backend/home",
    //backendAddress: "http://192.168.0.2:8080/paeweb-backend/home",
    //backendAddress: "http://143.106.67.54:8080/paeweb-backend/home",
    //backendAddress: "/paeweb-backend/home",
    backendAddress: "api",
    //googleSenderId: '217540633934',
    //refreshInterval: "2000" 

    search: {
	limit: 10
    },

    // caminho na lib do avalanche
    path: {
	process: '/process/',
	history: '/history/',
	commitment: '/commitment/',
	customer: '/client/',
	naturalPersonCustomer: '/client/naturalPerson/',
	legalEntityCustomer: '/client/legalEntity/',
	representative: '/representative/',
	provider: '/provider/', 
	naturalPersonProvider: '/provider/naturalPerson/', 
	legalEntityProvider: '/provider/legalEntity/', 
	user: '/user/', 
	documents: '/wikiDocuments/',
	files: '/files/',
	config: '/content/',
	mail: '/mail/',
	contract: '/contract/',
	entry: '/entry/',
	contactForm: '/contactForm/',
	comments: '/comments/',
	website: '/content/Menu/Home/'
    },

    folderTables: {
	"100003": "legalEntityCustomer",
	"100004": "naturalPersonCustomer",
	"100005": "naturalPersonProvider",
	"100006": "legalEntityProvider",
	"100007": "user",
	"100012": "entry"
    },
	
    datepickerFormat: 'dd/MM/yyyy',
    timepickerFormat: 'HH:mm',
    datetimeFormat: 'dd/MM/yyyy HH:mm',
    dateFormat: 'dd/MM/yyyy',
    taToolbar:  [
	['bold', 'italics', 'underline', 'undo', 'redo', 'clear'],
	['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull']
    ],

    discardTimeout: 5000,
    deleteTimeout: 5000,
    finalizarTimeout: 5000,
    saveDocHistory: true,

    cepConfig: {
	cidade: 'cidade_codigo',
	estado: 'uf_codigo',
	logradouro: 'logradouro',
	bairro: 'bairro'
    },

    searchCriteria: {
	customer: 'cnpj,ie,corporateName,name,cpf,rg',
	naturalPersonCustomer: 'name,cpf,rg',
	provider: 'cnpj,ie,corporateName,name,cpf,rg',
	user: 'name,cpf,rg',
	processos: 'keywords',
	mail: 'subject,message',
	documents: 'title,content'
    },

    fileListType: 'detailed',

    excludeFields: {
	process: ['userId','groupId','userRight','groupRight',
		  'otherRight','creationDate','lastChanged',
		  'lastChangedUserId','keywords']
    }
});
